import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * A slider for setting two percentage values at one.
 * @inheritDoc
 */
export class FormModelSlider extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'slider';

  constructor(id: string, validators: ValidatorFn[] = [], min: number = 0, max: number = 100, step: number = 1, unit: string = null, value: number = null, info: boolean = true) {
    super(id, validators, unit, value, info);

    this.fieldData.min = min;
    this.fieldData.max = max;
    this.fieldData.step = step;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelSlider {
    // @ts-ignore
    return new this.constructor(this.id, this.validators, this.fieldData.min, this.fieldData.max, this.fieldData.step, this.unit, this.value, this.info);
  }

}
